import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Protecao } from '@domain/dto/vehicle/vehicle-get.dto';

@Component({
  selector: 'app-protection-dialog',
  templateUrl: './protection-dialog.component.html',
  styleUrls: ['./protection-dialog.component.scss'],
})
export class ProtectionDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: Protecao) {}
}
